import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {WalletButton} from "../../../ui/WalletButton";
import {PaymentMethodStore} from "../../../../State";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {WidgetRoutes} from "../../../WidgetRoutes";
import {ErrorBanner} from "../../../ui/ErrorBanner";
import {LoadingWidget} from "../../../ui/LoadingWidget";
import {Dispatcher} from "../../../../../stem-core/src/base/Dispatcher";
import {Messages} from "../../../../Messages";
import {ADD_FUNDS_DISABLE_TIMEOUT} from "../../../../Constants";
import {WalletStore} from "../../../../State";
import {Money} from "../../../../../client/state/misc/Money";
import {Banner} from "../../../ui/Banner";
import {addCardAddedListener} from "../../../misc/WidgetUtils";
import {apiTopUp, TopUpStatus} from "../../../../../client/state/TopUpPaymentStore";


export class AddFundsButton extends WalletButton {
    disabled = false;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            amount: 0,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        if (this.disabled) {
            attr.setAttribute("disabled", true);
        }
    }

    getCurrency() {
        return WalletStore.getWallet().getCurrency();
    }

    render() {
        console.assert(this.getCurrency());
        return Messages.addFundsAmount((new Money(this.options.amount, this.getCurrency())).toMainUnitString({decimalsDisplayed: 0}));
    }

    getErrorMessage(error) {
        if (!error) {
            return Messages.failedAddFunds;
        }
        if (error.fields) {
            const remainingSeconds = error.fields.find(element => element.field === "remaining_seconds");
            if (remainingSeconds && remainingSeconds.message && remainingSeconds.message > 1) {
                // ensure we don't show "1 seconds"
                return Messages.topUpThrottle(remainingSeconds.message);
            }
        }
        // TODO: When we want to translate the app, this should be replaced.
        return error.message;
    }

    indicateDisabled() {
        this.disabled = true;
        this.redraw();
        this.attachTimeout(() => {
            this.disabled = false;
            this.redraw();
        }, ADD_FUNDS_DISABLE_TIMEOUT);
    }

    async addFunds() {
        const primaryCard = PaymentMethodStore.getPrimary();
        if (!primaryCard) {
            Router.changeURL(WidgetRoutes.ADD_CARD);
            addCardAddedListener(this, () => this.addFunds());
            return;
        }
        Banner.hide();
        const currency = this.getCurrency();
        if (!currency) {
            return;
        }

        try {
            const transaction = await LoadingWidget.walletLoad(() => apiTopUp(this.options.amount, primaryCard, currency));
            if (transaction.status === TopUpStatus.FAILED) {
                ErrorBanner.show(Messages.failedAddFunds);
            } else {
                Dispatcher.Global.dispatch("shouldCollapseAddFunds");
            }
        } catch (error) {
            ErrorBanner.show(this.getErrorMessage(error));
        } finally {
            this.indicateDisabled();
        }
    }

    onMount() {
        super.onMount();

        this.addClickListener(() => this.addFunds());
    }
}
